import Utils from "../utils/utilities"

const LOADING_CLASS: string = 'loading'

const errorHandler: Function = (reject, response) => {
    console.error('There was an error in the HTTP request.', response)
    document.body.classList.remove(LOADING_CLASS)
    reject(response)
}

export function requestEndpoint(url: string, method?: string, body?: any): Promise<any> {
    return new Promise((resolve, reject) => {
        const httpRequest: XMLHttpRequest = new XMLHttpRequest()

        document.body.classList.add(LOADING_CLASS)

        httpRequest.addEventListener('load', e => {
            const response: any = e.currentTarget

            document.body.classList.remove(LOADING_CLASS)

            if (response.readyState === 4 && (response.status === 200 || response.status === 303)) resolve(response)
            else errorHandler(reject, response)
        })

        httpRequest.addEventListener('error', response => errorHandler(reject, response))
        httpRequest.addEventListener('abort', response => errorHandler(reject, response))

        httpRequest.open(Utils.isDefined(method) ? method : 'GET', url, true)
        httpRequest.setRequestHeader('Content-type', 'application/json')

        if (Utils.isDefined(body)) httpRequest.send(JSON.stringify(body))
        else httpRequest.send()
    })
}